import type { GetScheduleHistory } from "@/server-types";
import { get } from "../request-helpers";
import { useCustomQuery } from "../custom-query";

/**
 * GET /schedule/[scheduleId]/history
 */
export const useScheduleHistory = (
  scheduleId: number,
  query: GetScheduleHistory["query"],
  options?: { enabled?: boolean },
) => {
  return useCustomQuery({
    queryKey: ["getScheduleHistory", scheduleId, query],
    queryFn: () =>
      get<GetScheduleHistory>(`/schedule/${scheduleId}/history`, query),
    enabled: options?.enabled,
  });
};
